import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import NavTab from '../../components/Topbar/NavTab';
import { navItems } from '../../utils/staticData';
import ActionButtons from '../../components/Topbar/ActionButtons';
import { alertWrapper } from '../../utils/alertWrapper';
import {
  setSelectedCategory,
  setIsDataReady
} from '../../containers/customizer.duck';

const Topbar = ({
  siteUrl,
  userId,
  undoChanges,
  redoChanges,
  showUndoStack,
  showRedoStack,
  openAlertDialog,
  customizer,
  setIsDashboardOpen,
  selectedVariant,
  onSaveChanges,
  isConfigSaved,
  setIsDataReady,
  activeTab,
  setIsLoading,
  setSelectedCategory,
  getAccessoryVariantData,
  getAllAccessoryTypeDataOnTabClick,

  savePartsConfiguration
}) => {
  const { push } = useHistory();
  const onNavChange = value => {
    setIsDataReady(false);

    switch (value) {
      case 0:
        setIsLoading(true);
        push('/jackets');
        break;
      case 1:
        push('/helmet');
        break;
      case 2:
        setIsLoading(true);
        push('/tshirt');
        break;
      default:
        push('/helmet');
    }
  };

  useEffect(() => {
    if (activeTab === 'helmet') {
      getAllAccessoryTypeDataOnTabClick('helmet');
      setSelectedCategory('helmetType');
    } else if (activeTab === 'tshirt') {
      getAllAccessoryTypeDataOnTabClick('tshirt');
      getAccessoryVariantData('TShirt');
    } else if (activeTab === 'jacket') {
      getAllAccessoryTypeDataOnTabClick('jacket');
    } else getAllAccessoryTypeDataOnTabClick('helmet');
  }, [activeTab]);

  return (
    <div className="top-bar">
      <NavTab
        currentTab={activeTab}
        items={navItems}
        onChange={value => {
          alertWrapper(
            {
              isOpen: !isConfigSaved,
              title: 'Customization Not Saved',
              message:
                'Navigating without saving will result in lose of customization. Click on Save on Topbar or continue anyway without saving',
              agreeButtonText: 'Continue Anyway',
              disagreeButtonText: 'Cancel',
              onAgree: () => {
                onNavChange(value);
              },
              onDisagree: () => {}
            },
            openAlertDialog,
            !isConfigSaved
          );
        }}
      />
      <div className="top-bar_action-btns">
        {/* <ActionButtons
          selectedVariant={selectedVariant}
          undoChanges={() => {
            alertWrapper(
              {
                isOpen: true,
                title: 'Undo',
                message: 'Are you sure you want to undo this customization?',
                agreeButtonText: 'Confirm',
                disagreeButtonText: 'Cancel',
                onAgree: () => {
                  undoChanges();
                },
                onDisagree: () => {}
              },
              openAlertDialog,
              true
            );
          }}
          onSaveClick={() => {
            onSaveChanges();
            savePartsConfiguration(customizer);
          }}
          onCollectionsClick={() => {
            if (userId === null) {
              // user is not logged in
              // window.parent.postMessage(
              //   { module: (selectedVariant === 'TShirt') ? 'tshirt' :'helmet', event: 'login', configId: '' },
              //   siteUrl !== null ? siteUrl : '*'
              // );
            } else {
              setIsDashboardOpen();
            }
          }}
          redoChanges={redoChanges}
          showUndoStack={showUndoStack}
          showRedoStack={showRedoStack}
          isConfigSaved={isConfigSaved}
        /> */}
      </div>
    </div>
  );
};

Topbar.propTypes = {
  undoChanges: PropTypes.func,
  redoChanges: PropTypes.func,
  showUndoStack: PropTypes.bool,
  showRedoStack: PropTypes.bool,
  openAlertDialog: PropTypes.func,
  customizer: PropTypes.object,
  setIsDashboardOpen: PropTypes.func,
  onSaveChanges: PropTypes.func,
  isConfigSaved: PropTypes.bool,
  savePartsConfiguration: PropTypes.func
};

export default Topbar;
